import React from 'react';
import { BsCheckCircleFill, BsXCircleFill, BsExclamationTriangleFill, BsInfoCircleFill, BsX } from 'react-icons/bs';

const iconMap = {
  success: BsCheckCircleFill,
  error: BsXCircleFill,
  warning: BsExclamationTriangleFill,
  info: BsInfoCircleFill,
};

const Toast = ({ id, type, message, isExiting, onClose }) => {
  const Icon = iconMap[type] || BsInfoCircleFill;

  return (
    <div
      className={`otos-toast otos-toast--${type} ${isExiting ? 'otos-toast--exiting' : ''}`}
      role="alert"
      aria-live="polite"
    >
      <div className="otos-toast__icon">
        <Icon />
      </div>
      <div className="otos-toast__content">
        <p className="otos-toast__message">{message}</p>
      </div>
      <button
        className="otos-toast__close"
        onClick={() => onClose(id)}
        aria-label="Close notification"
        type="button"
      >
        <BsX />
      </button>
    </div>
  );
};

export default Toast;
